import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import GooglePlayImg from '../../assets/icons/googleplay-active.svg';
import AppStoreImg from '../../assets/icons/appstore-active.svg';
import LogoSm from '../../assets/icons/logo-sm.svg';
import { SocialImage } from '../../components/Welcome/Welcome';
import { Link } from 'react-scroll';

const Footer = () => {
  return (
    <FooterContainer>
      <Container>
        <FooterRow>
          <FooterColumn>
            <FooterLogo src={LogoSm} alt="logo" />
            <FooterNav>
              <Link to="conditions">
                <FooterNavItem>Условия</FooterNavItem>
              </Link>
              <Link to="equipment">
                <FooterNavItem>Наше оборудование</FooterNavItem>
              </Link>
              <Link to="advantages">
                <FooterNavItem>Преимущества</FooterNavItem>
              </Link>
              <Link to="about">
                <FooterNavItem>О нас</FooterNavItem>
              </Link>
              <Link to="contact">
                <FooterNavItem>Контакты</FooterNavItem>
              </Link>
            </FooterNav>
            <FooterText>Политика конфиденциальности</FooterText>
            <FooterCopyRight>© 2019-2022 Energo</FooterCopyRight>
          </FooterColumn>
          <FooterButtonsColumn>
            <FooterTextApp>Установить приложение</FooterTextApp>
            <a href="https://apps.apple.com/ru/app/energo-%D0%B0%D1%80%D0%B5%D0%BD%D0%B4%D0%B0-%D0%BF%D0%B0%D0%B2%D0%B5%D1%80%D0%B1%D0%B0%D0%BD%D0%BA%D0%BE%D0%B2/id1507114521">
              <FooterButton src={AppStoreImg} alt="app-store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.energo.rnapp&hl=ru&gl=US">
              <FooterButton src={GooglePlayImg} alt="app-store" />
            </a>
          </FooterButtonsColumn>
        </FooterRow>
      </Container>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background: #26292d;
  color: #ffffff;
  padding: 56px 0;

  @media (max-width: 599px) {
    padding: 56px 0 61px 0;
  }
`;

const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const FooterButton = styled(SocialImage)`
  margin-top: 1.2rem;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterButtonsColumn = styled(FooterColumn)`
  align-items: flex-end;
  @media (max-width: 599px) {
    width: 50%;
  }
`;

const FooterText = styled.span`
  font-weight: 400;
  font-size: 16px;
  @media (max-width: 599px) {
    line-height: 24px;
  }
`;

const FooterTextApp = styled(FooterText)`
@media (max-width: 400px) {
  font-size: 13px;
`;

const FooterCopyRight = styled.span`
  font-size: 14px;
  margin-top: 2rem;
  @media (max-width: 599px) {
    margin-top: 27px;
  }
`;

const FooterLogo = styled.img`
  width: 32px;
  heiht: 32px;
`;

const FooterNav = styled.ul`
  display: flex;
  justify-content: space-between;
  padding-left: 0 !important;
  margin-top: 0.7rem;
  margin-bottom: 1.2rem;
  @media (max-width: 1135px) {
    flex-wrap: wrap;
    row-gap: 10px;
    justify-content: flex-start;
  }
  @media (max-width: 599px) {
    flex-direction: column;
    row-gap: 16px;
  }
`;

const FooterNavItem = styled.li`
  margin-right: 25px;
  cursor: pointer;
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px solid #fff;
  }
  @media (max-width: 1135px) {
    margin-right: 15px;
  }
`;

export default Footer;
